import { Spin, Typography } from 'antd'
import { observer } from 'mobx-react-lite'

import {
    ASSIGNMENT_STATUS_MAP,
    type AssignmentStatus,
} from '@/Containers/AssignmentSection/AssignmentContainer/Contracts/AssignmentStatus'
import { OpenResourceCardTask } from '@/Core/Tasks/Resources/OpenResourceCardTask'
import { StatusBadge } from '@/Ship/Components/UI/StatusBadge/StatusBadge'
import { formatAppDate } from '@/Ship/Helpers/appTime'

import { assignmentRouteLabel, type ShiftAssignmentsStore } from '../Stores/ShiftAssignmentsStore'

const { Text } = Typography

const statusOption = (status: string) => {
    const info = ASSIGNMENT_STATUS_MAP[status as AssignmentStatus]
    return info ? { value: status, label: info.label, color: info.color } : undefined
}

/**
 * Задачі зміни: номер (відкриває картку задачі), статус, маршрут і планова дата завантаження.
 * Стор вантажить шаблон картки — лічильник потрібен на вкладці ще до її відкриття.
 * Ресурс задачі — за ключем реєстру, не імпортом: картка задачі сама посилається на зміну.
 */
export const ShiftAssignments = observer(({ store }: { store: ShiftAssignmentsStore }) => {
    if (store.loading && !store.items.length) return <Spin style={{ display: 'block', margin: '20px auto' }} />
    if (store.error) return <Text type="danger">{store.error}</Text>
    if (!store.items.length) return <Text type="secondary">До зміни не прив'язано жодної задачі</Text>

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {store.items.map((item) => {
                const route = assignmentRouteLabel(item)
                const planned = item.plannedLoadingDate
                    ? formatAppDate(item.plannedLoadingDate, 'DD.MM.YYYY, HH:mm')
                    : null
                return (
                    <div key={item.uuid} data-testid="shift-assignment-item">
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            <Typography.Link
                                onClick={() =>
                                    OpenResourceCardTask({
                                        // Ключ реєстру ресурсів — «Розділ.Ресурс» (не resource.key)
                                        resource: 'Assignment.Assignment',
                                        primaryFieldValue: item.uuid,
                                        mode: 'view',
                                    })
                                }
                            >
                                Задача #{item.id}
                            </Typography.Link>
                            <StatusBadge option={statusOption(item.status)} fallbackLabel={item.status} />
                        </div>
                        {(route || planned) && (
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                {[route, planned && `завантаження ${planned}`].filter(Boolean).join(' · ')}
                            </Text>
                        )}
                    </div>
                )
            })}
            {store.total > store.items.length && (
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Показано перші {store.items.length} з {store.total}
                </Text>
            )}
        </div>
    )
})
